import { GraphQLFieldConfig, GraphQLNonNull } from 'graphql'
import { ApplicationPageType, ApplicationPage } from '../types/application-page'
import { ApplicationOrder } from '../types/application-order'
import { Context } from '../shared'
import {
  applicationPagingArgs,
  ApplicationPagingArgs
} from '../types/application-paging-args'
import { ApplicationOrderField } from '../types/application-order-field'
import { normalizeApplication } from './helpers/application'
import {
  ContrastQueryParameters,
  appendApplicationFiltersToBody
} from '../endpoint-helpers'

const orderMap: { [key in ApplicationOrderField]: string } = {
  NAME: 'appName',
  IMPORTANCE: 'appImportance',
  LANGUAGE: 'appLanguage'
}

export function appendSortToParams(
  params: ContrastQueryParameters,
  orderBy: ApplicationOrder | undefined
) {
  if (orderBy) {
    const { field, direction } = orderBy
    params.append(
      'sort',
      `${direction === 'DESC' ? '-' : ''}${orderMap[field]}`
    )
  }
}

export const applications: GraphQLFieldConfig<
  any,
  Context,
  ApplicationPagingArgs
> = {
  description: 'Get a page of applications',
  type: new GraphQLNonNull(ApplicationPageType),
  args: applicationPagingArgs,
  async resolve(_source, args, context): Promise<Partial<ApplicationPage>> {
    const { offset, limit, organizationID, orderBy, filters } = args

    const params = new ContrastQueryParameters()
    params.append('offset', offset)
    params.append('limit', limit)
    params.append(
      'expand',
      'license,compliance_policy,skip_links,technologies,trace_severity_breakdown,metadata,scores'
    )
    appendSortToParams(params, orderBy)

    const mappedFilters = appendApplicationFiltersToBody(filters)
    // using POST as it has no restrictions on data length, unlike GET, which is limited by URL length
    const { applications = [], count: total } = await context.connector.post(
      `/${organizationID}/applications/filter?${params}`,
      mappedFilters
    )

    return {
      total,
      items: applications.map(normalizeApplication)
    }
  }
}
